<template>
  <div class="row">
    <div class="col-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateAdvancedAudit"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @fillAdvancedAuditForm="fillAdvancedAuditForm"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.sub_category_and_tasks')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              :generalTaskPercentage="getPercentage"
              @on-validated="onStepValidated"
              @fillAdvancedAuditForm="fillAdvancedAuditForm"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              5.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-11 table-responsive">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ advancedAuditForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        <template v-if="advancedAuditForm.description">
                          {{ advancedAuditForm.description }}
                        </template>
                        <el-tag class="mt-2" v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong>{{ $t('common_words.type_grade') }}:</strong>
                        </h6>
                        <el-tag type="info">{{
                          advancedAuditForm.type
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.type_capture') }}:</strong
                          >
                        </h6>
                        <el-tag type="info">{{
                          advancedAuditForm.audit_type_label
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.record_quantity') }}:</strong
                          >
                        </h6>
                        {{ advancedAuditForm.total_records }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.records_name') }}:</strong
                          >
                        </h6>

                        <template v-if="advancedAuditForm.record_name">
                          {{ advancedAuditForm.record_name }}
                        </template>
                        <el-tag class="mt-2" v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.general_percentage_by_task')
                            }}:</strong
                          >
                        </h6>
                        <template v-if="advancedAuditForm.discount_percentage">
                          {{ advancedAuditForm.discount_percentage }} %
                        </template>
                        <el-tag class="mt-2" v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(
                            business, index
                          ) in advancedAuditForm.business_name"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_profiles2')
                            }}:</strong
                          >
                        </h6>
                        <template
                          v-if="advancedAuditForm.roles_name.length > 0"
                        >
                          <span
                            v-for="(
                              role, index
                            ) in advancedAuditForm.roles_name"
                            :key="index"
                          >
                            <el-tag type="info">{{ role }}</el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.associated_users2') }}:</strong
                          >
                        </h6>
                        <template
                          v-if="advancedAuditForm.users_name.length > 0"
                        >
                          <span
                            v-for="(
                              user, index
                            ) in advancedAuditForm.users_name"
                            :key="index"
                          >
                            <el-tag type="info">{{ user }}</el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="warning">{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table mb-4">
                          <strong
                            >{{
                              $t('common_words.sub_associated_category')
                            }}:</strong
                          >
                        </h6>
                        <div
                          v-if="
                            advancedAuditForm.sub_category_names &&
                            advancedAuditForm.sub_category_names.length > 0
                          "
                        >
                          <table aria-describedby="tabla-calidad" class="table">
                            <thead>
                              <tr>
                                <td></td>
                                <td>{{ $t('common_words.mayus_tasks') }}</td>
                                <td>{{ $t('common_words.mayus_type') }}</td>
                                <td>
                                  {{
                                    $t('common_words.mayus_associated_value')
                                  }}
                                </td>
                                <td>
                                  {{ $t('common_words.product_percentage') }}
                                </td>
                                <td>
                                  {{ $t('common_words.value_percentage') }}
                                </td>
                                <td>
                                  {{ $t('common_words.photo_questionmark') }}
                                </td>
                                <td>
                                  {{ $t('common_words.required_questionmark') }}
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(index, order) in orderData(
                                  advancedAuditForm.subcategoryOrder
                                )"
                                :key="order"
                              >
                                <td>
                                  <el-tag
                                    style="height: auto"
                                    type="info"
                                    v-if="
                                      advancedAuditForm.sub_category_names[
                                        index
                                      ]
                                    "
                                  >
                                    <span
                                      v-tooltip.top-center="
                                        advancedAuditForm.sub_category_names[
                                          index
                                        ].length > 15
                                          ? `${order} - ${advancedAuditForm.sub_category_names[index]}`
                                          : ``
                                      "
                                    >
                                      {{ $t('common_words.order_request') }}:
                                      {{ order }}<br />
                                      {{ $t('common_words.name') }}:
                                      {{
                                        advancedAuditForm.sub_category_names[
                                          index
                                        ].substring(0, 15)
                                      }}{{
                                        advancedAuditForm.sub_category_names[
                                          index
                                        ].length > 15
                                          ? `...`
                                          : ``
                                      }}<br />
                                      {{ $t('common_words.general') }}:
                                      {{
                                        advancedAuditForm.isGeneral[index]
                                          ? 'Si'
                                          : 'No'
                                      }}<br />
                                      {{ $t('common_words.percentage') }}:
                                      {{
                                        getFormatNumber(
                                          advancedAuditForm.valuePercentage[
                                            index
                                          ]
                                        )
                                      }}%
                                    </span>
                                  </el-tag>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-if="
                                        advancedAuditForm.task_names[taskIndex]
                                      "
                                      :key="orderTask"
                                    >
                                      <span
                                        v-tooltip.top-center="
                                          advancedAuditForm.task_names[
                                            taskIndex
                                          ].length > 32
                                            ? `${orderTask} - ${advancedAuditForm.task_names[taskIndex]}`
                                            : ``
                                        "
                                      >
                                        {{ orderTask }}
                                        -
                                        {{
                                          advancedAuditForm.task_names[
                                            taskIndex
                                          ].substring(0, 32)
                                        }}{{
                                          advancedAuditForm.task_names[
                                            taskIndex
                                          ].length > 32
                                            ? `...`
                                            : ``
                                        }}
                                      </span>
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, order) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        advancedAuditForm.calification_type[
                                          taskIndex
                                        ]
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="order"
                                    >
                                      {{
                                        advancedAuditForm.calification_type[
                                          taskIndex
                                        ]
                                      }}
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-tooltip.top-center="
                                        showOptionTask(
                                          advancedAuditForm.task_values[
                                            taskIndex
                                          ]
                                        ).length > 60
                                          ? showOptionTask(
                                              advancedAuditForm.task_values[
                                                taskIndex
                                              ]
                                            )
                                          : ``
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                      v-if="
                                        advancedAuditForm.task_values[
                                          taskIndex
                                        ] &&
                                        advancedAuditForm.calification_type[
                                          taskIndex
                                        ] &&
                                        ['Única', 'Múltiple'].includes(
                                          advancedAuditForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      {{
                                        showOptionTask(
                                          advancedAuditForm.task_values[
                                            taskIndex
                                          ]
                                        ).substring(0, 60)
                                      }}
                                      {{
                                        showOptionTask(
                                          advancedAuditForm.task_values[
                                            taskIndex
                                          ]
                                        ).length > 60
                                          ? `...`
                                          : ``
                                      }}
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        advancedAuditForm.calification_type[
                                          taskIndex
                                        ] == 'Subjetiva'
                                      "
                                    >
                                      <label class="row subject-calification">
                                        <div class="px-0 mr-1">
                                          <el-tag
                                            type="info"
                                            style="width: 30px"
                                          >
                                            0
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag
                                            type="info"
                                            style="width: 30px"
                                          >
                                            10
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag
                                            type="info"
                                            style="width: 38px"
                                          >
                                            NA
                                          </el-tag>
                                        </div>
                                        <div class="px-0 mr-1">
                                          <el-tooltip placement="top">
                                            <div slot="content">
                                              <p>
                                                <strong>
                                                  {{
                                                    $t('audit.compliance_type')
                                                  }}
                                                  :
                                                </strong>
                                                {{
                                                  advancedAuditForm
                                                    .type_discount[taskIndex] ==
                                                  'Variado'
                                                    ? $t('audit.variable')
                                                    : $t('audit.fixed')
                                                }}
                                              </p>
                                              <div
                                                v-for="(
                                                  val, key
                                                ) in getDiscountByTaskIndex(
                                                  taskIndex
                                                )"
                                                :key="key"
                                                v-if="
                                                  advancedAuditForm
                                                    .type_discount[
                                                    taskIndex
                                                  ] === 'Variado'
                                                "
                                              >
                                                <p>
                                                  <strong>
                                                    {{
                                                      $t('common_words.range')
                                                    }}:
                                                  </strong>
                                                  {{ key }} -
                                                  <strong>
                                                    {{
                                                      $t('common_words.value')
                                                    }}:
                                                  </strong>
                                                  {{ getFormatNumber(val) }}%
                                                </p>
                                              </div>
                                            </div>
                                            <a>
                                              <em
                                                class="fa fa-eye custom-size-fa-actions"
                                              >
                                              </em>
                                            </a>
                                          </el-tooltip>
                                        </div>
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        advancedAuditForm.calification_type[
                                          taskIndex
                                        ] == 'Subjetiva 2'
                                      "
                                    >
                                      <label class="row subject-calification">
                                        <div class="px-0 mr-1">
                                          <el-tag
                                            type="info"
                                            style="width: 30px"
                                          >
                                            0
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag
                                            type="info"
                                            style="width: 30px"
                                          >
                                            5
                                          </el-tag>
                                        </div>
                                        ...
                                        <div class="px-0 mr-1">
                                          <el-tag
                                            type="info"
                                            style="width: 38px"
                                          >
                                            NA
                                          </el-tag>
                                        </div>
                                        <div class="px-0 mr-1">
                                          <el-tooltip placement="top">
                                            <div slot="content">
                                              <p>
                                                <strong>
                                                  {{
                                                    $t('audit.compliance_type')
                                                  }}
                                                  :
                                                </strong>
                                                {{
                                                  advancedAuditForm
                                                    .type_discount[taskIndex] ==
                                                  'Variado'
                                                    ? $t('audit.variable')
                                                    : $t('audit.fixed')
                                                }}
                                              </p>
                                              <div
                                                v-for="(
                                                  val, key
                                                ) in getDiscountByTaskIndex(
                                                  taskIndex
                                                )"
                                                :key="key"
                                                v-if="
                                                  advancedAuditForm
                                                    .type_discount[
                                                    taskIndex
                                                  ] === 'Variado'
                                                "
                                              >
                                                <p>
                                                  <strong>
                                                    {{
                                                      $t('common_words.range')
                                                    }}:
                                                  </strong>
                                                  {{ key }} -
                                                  <strong>
                                                    {{
                                                      $t('common_words.value')
                                                    }}:
                                                  </strong>
                                                  {{ getFormatNumber(val) }}%
                                                </p>
                                              </div>
                                            </div>
                                            <a>
                                              <em
                                                class="fa fa-eye custom-size-fa-actions"
                                              >
                                              </em>
                                            </a>
                                          </el-tooltip>
                                        </div>
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        ['Numérica', 'Texto'].includes(
                                          advancedAuditForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      <label
                                        class="font-weight-light"
                                        style="font-size: 14px"
                                      >
                                        {{ showRangeSelected(taskIndex) }}
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        advancedAuditForm.task_values[
                                          taskIndex
                                        ] &&
                                        advancedAuditForm.calification_type[
                                          taskIndex
                                        ] &&
                                        [
                                          'Fuente de Datos',
                                          'Fuente de Datos Múltiple',
                                        ].includes(
                                          advancedAuditForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      {{
                                        advancedAuditForm.data_source_selected[
                                          taskIndex
                                        ]
                                      }}
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        ['Numérica', 'Texto'].includes(
                                          advancedAuditForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      <label
                                        class="font-weight-light"
                                        style="font-size: 14px"
                                      >
                                        {{ showRangeSelected(taskIndex) }}
                                      </label>
                                    </p>
                                    <p
                                      class="d-flex align-items-center size-cell"
                                      v-else-if="
                                        ['Fecha', 'Hora', 'Objetiva'].includes(
                                          advancedAuditForm.calification_type[
                                            taskIndex
                                          ]
                                        )
                                      "
                                    >
                                      {{ $t('common_words.does_not_apply') }}
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="true"
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                    >
                                      {{
                                        getFormatNumber(
                                          advancedAuditForm.taskDcto[taskIndex]
                                        )
                                      }}%
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="true"
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                    >
                                      {{
                                        Number(
                                          getFormatNumber(
                                            advancedAuditForm.taskPercentage[
                                              taskIndex
                                            ]
                                          )
                                        )
                                      }}%
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, orderTask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        advancedAuditForm.photo_required[
                                          taskIndex
                                        ] !== undefined
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="orderTask"
                                    >
                                      {{
                                        advancedAuditForm.photo_required[
                                          taskIndex
                                        ]
                                          ? 'Si'
                                          : 'No'
                                      }}
                                    </p>
                                  </template>
                                </td>
                                <td>
                                  <template
                                    v-for="(taskIndex, ordertask) in orderData(
                                      getOrderTask(index)
                                    )"
                                  >
                                    <p
                                      v-if="
                                        advancedAuditForm.is_required[
                                          taskIndex
                                        ] !== undefined
                                      "
                                      class="d-flex align-items-center size-cell"
                                      :key="ordertask"
                                    >
                                      {{
                                        advancedAuditForm.is_required[taskIndex]
                                          ? 'Si'
                                          : 'No'
                                      }}
                                    </p>
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <el-tag
                          type="warning"
                          v-if="
                            !advancedAuditForm.sub_category_names ||
                            advancedAuditForm.sub_category_names.length == 0
                          "
                          >{{
                            $t('common_words.no_sub_associated_category')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import { Slider } from 'element-ui';
import FirstStep from './steps/FirstStep.vue';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinNumbers from 'src/util/mixinNumbers';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
    [Slider.name]: Slider,
  },

  computed: {
    getPercentage() {
      const value = Number(this.advancedAuditForm.discount_percentage);

      return value ? value : 0;
    },
  },

  data() {
    return {
      title: '',
      advancedAuditForm: {
        discount_percentage: 0,
        name: null,
        description: null,
        total_records: null,
        record_name: null,
        catch_type: null,
        audit2_type: 'web',
        business_name: null,
        sub_category_ids: [],
        subcategoryOrder: [],
        sub_category_names: [],
        task_ids: [],
        task_names: [],
        task_order: [],
        users_name: [],
        roles_name: [],
      },
      wizardModel: {},
    };
  },

  mixins: [MixinPermissions, MixinMasters, MixinNumbers, MixinMenu],

  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(Number(value), 3);
    },

    showOptionTask(items) {
      return `["${items.join('", "')}"]`;
    },

    orderData(data) {
      let array = [];
      try {
        array = Object.entries(data);
      } catch (error) {
        //
      }

      array.sort((a, b) => a[1] - b[1]);
      const sortedObj = Object.fromEntries(
        array.map(([value, key]) => [key, value])
      );

      return sortedObj;
    },

    getOrderTask(indexSubcategory) {
      let a = 0;
      const response = [];
      while (a < this.advancedAuditForm.tasks_number[indexSubcategory]) {
        response.push(`${indexSubcategory}-${a}`);
        a++;
      }

      response.sort((a, b) => a - b);

      const array = Object.entries(this.advancedAuditForm.task_order);
      const orderTask = {};
      array.forEach((data) => {
        if (response.includes(data[0])) {
          orderTask[data[0]] = data[1];
        }
      });
      return orderTask;
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
        total_records: 1,
        audit2_type: 'web',
      };
      this.$refs.secondStep.cleanStep();
    },

    showRangeSelected(index) {
      try {
        return (
          'Min: ' +
          this.roundNumber(
            this.advancedAuditForm.task_numeric_values[index][0],
            2
          ) +
          ' - Max: ' +
          this.roundNumber(
            this.advancedAuditForm.task_numeric_values[index][1],
            2
          )
        );
      } catch (error) {
        return '';
      }
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },

    fillAdvancedAuditForm(ref, others) {
      this.advancedAuditForm = Object.assign(
        {},
        this.advancedAuditForm,
        this.$refs[ref].model
      );

      if (others)
        this.advancedAuditForm = Object.assign(
          {},
          this.advancedAuditForm,
          others
        );
    },

    getDiscountByTaskIndex(taskIndex) {
      const discounts = {};
      if (
        this.advancedAuditForm.discount_variable_subj &&
        typeof this.advancedAuditForm.discount_variable_subj === 'object'
      ) {
        Object.entries(this.advancedAuditForm.discount_variable_subj).forEach(
          ([key, value]) => {
            if (key.startsWith(`${taskIndex}-`)) {
              const range = key.split('-').pop();
              discounts[range] = value;
            }
          }
        );
      }

      return discounts;
    },

    storeUpdateAdvancedAudit() {
      this.showHideLoading(true);
      this.advancedAuditForm.route = 'advanced/audits/admin';
      //formateo la propiedad discount_variable_subj de un objeto pasa a un array
      // de arrays para ser usados en el backend
      const grouped = {};
      Object.entries(this.advancedAuditForm.discount_variable_subj).forEach(
        ([key, value]) => {
          const [i, j, k] = key.split('-');
          const groupKey = `${i}-${j}`;

          if (!grouped[groupKey]) {
            grouped[groupKey] = {};
          }

          grouped[groupKey][k] = value;
        }
      );
      this.advancedAuditForm.discount_variable_subj = Object.entries(grouped);
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.advancedAuditForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.advancedAuditForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/advanced/audits/admin',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.advancedAuditForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/advanced/audits/admin',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('advanced');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style></style>
